
const tableDescriptor = {
    model: 'table',//шаблон дескриптора
    title: 'organization',
    columns: [//описание столбцов таблицы
        
        {
          title: 'name',
          value: 'name',
          translate: false,
          dataKey: 'name',
          filter: true,
          type: 'text',
          width: '30%',
        },
        {
          title: 'email',
          value: 'email',
          translate: false,
          dataKey: 'email',
          filter: true,
          type: 'text',
          width: '20%'
        },
        {
          title: 'phone_1',
          value: 'phone_1',
          translate: false,
          dataKey: 'phone_1',
          filter: true,
          type: 'text',
          width: '20%'
        },
        {
          title: 'address',
          value: 'address_f',
          translate: false,
          dataKey: 'address_f',
          filter: true,
          type: 'text',
          width: '20%'
        },
        
    ],

    pageLimit: 40,//количество строк на одной странице таблицы
    page: 1,//дефолтная страница
    nextPageButton: true,//вкл/выкл пагинатор

    sortable: false,//флаг вкл/выкл сортировки таблицы по столбцам
    subscribed: true,//флаг вкл/выкл подписки строк на статусы (раскрашивает строки в цвета статусов строк)
    translate: true,//флаг вкл/выкл перевод (i18n) заголовков и значений
    toolbar: null,//добавляет дполонительный тулбар над шапкой таблицы (принимает строку как title. Это заготовка для размещения дополнительных функциональных элементов)   
    rowclick: true,//флаг определяет логику обработки click по ячейкам таблицы (true - клик на строку, false - клик на ячейку)
    removable: false,//добавляет столбец "действия" с кнопкой "удалить строку"
    resizable: false,//флаг вкл/выкл изменения размеров столбцов вручную (функционал требует допила)
    header: false,//флаг определяет позиционирование заголовков столбцов (внутри прокрутки или вне её)
    addButton: false,//добавляет кнопку "добавить" в заголовок первого столбца (используется для добавления внешних измерений в таблицу мониторинга устройства)
    activeActions: true,//вкл/выкл обработку событий "measureOff" для измерений
    hideState: [],//скрывает строки свойство state которых присутствует в массиве hideState. Принимает массив строк.
    hideValues: ['undefined'],//заменяет на '' (пустую строку) значения, приведенные в массиве hideValues. Принимает массив строк.

    filterBar: true,//флаг вкл/выкл фильтр бар

}

export default tableDescriptor